<template>
  <div v-if="dataForm.presentRecruitmentProessList">
    <!--评估中心流程进度 -->
    <div>
      <div :style="{position:'relative', background: '#ffffff', height: fullHeight1 * (1.0 + ( 0.4 * (this.dataForm.presentRecruitmentProessList.length - 1)) ) +'px'}">
        <img alt="" ref="assessImg" src="@/assets/img/assessmentinfo/评估中心背景_3.png" style="width: 100%; position:absolute">
        <img alt="" src="@/assets/img/assessmentinfo/评估中心背景_3_1.png" :style="{position:'absolute', top:fullHeight * (0.3 + 0.40 * 0) + 'px', width: '100%'}">
        <div v-if="dataForm.presentRecruitmentProessList" v-for="(item,i) in dataForm.presentRecruitmentProessList">
          <!--总经理 userinfo -->
          <div :style="{position:'absolute', top:fullHeight * (0.32 + 0.40 * i) + 'px', left: '5%',}">
            <div>
              <span style="font-size:18px;font-weight:800">
                {{item.jobName}}
              </span>
              <span>
                {{item.orgName}}
              </span>
              <span>
                ｜
              </span>
              <span>
                {{item.brand}}
              </span>
              <span>
                |
              </span>
              <span>
                {{item.networkType}}
              </span>
            </div>
          </div>
          <!-- 下面横条 -->
          <div :style="{position:'absolute', top:fullHeight * (0.34 + 0.40 * i) + 'px', left: '5%', width:'1000px'}" class="dirider">
            <el-divider></el-divider>
          </div>
          <!--导航 Navigation -->
          <div :style="{position:'absolute', top:fullHeight * (0.40 + 0.40 * i) + 'px', left: '15%', width: '90%'}"
               class="divrow assement-my-nav">
            <el-row class="row1">
              <el-col :span="3" class="container assement-my-container" v-if="item.recruitmentStepList[0].status">
                <div :class="['dialog',{'disabledImg':item.recruitmentStepList[0].status === '10'}]">
                  <img alt="" src="@/assets/img/ac/1223_1.png" :class="['assement-my-icon', {'big': item.recruitmentStepList[0].status === '20'}]">
                  <p class="assement-my-title">{{ $t('assessment.improve') }}</p>
                </div>
              </el-col>
              <el-col :span="2" class="container assement-my-container assement-my-container2">
                <div v-if="item.recruitmentStepList[1].status === '10'" class="dialog">
                  <img alt="" src="@/assets/img/assessmentinfo/1231_0_1.png" class="img-arrow">
                </div>
                <div v-else class="dialog">
                  <img alt="" src="@/assets/img/assessmentinfo/1231_0.png" class="img-arrow">
                </div>
              </el-col>
              <el-col :span="3" class="container assement-my-container" v-if="item.recruitmentStepList[1].status">
                <div v-if="item.recruitmentStepList[1].status === '10'" class="dialog">
                  <img alt="" src="@/assets/img/ac/1223_4_1.png" class="assement-my-icon">
                  <p class="assement-my-title assement-my-title2">{{ $t('protal.CapabilityAssessment') }}</p>
                </div>
                <div class="dialog" v-else>
                  <img alt="" src="@/assets/img/ac/1223_4.png" :class="['assement-my-icon',{'big': item.recruitmentStepList[1].status === '20'}]">
                  <p :class="['assement-my-title',{'big': item.recruitmentStepList[1].status === '20'}]">{{ $t('protal.CapabilityAssessment') }}</p>
                </div>
              </el-col>
              <el-col :span="2" class="container assement-my-container assement-my-container2">
                <div v-if="item.recruitmentStepList[2].status === '10'" class="dialog">
                  <img alt="" src="@/assets/img/assessmentinfo/1231_0_1.png" class="img-arrow">
                </div>
                <div v-else class="dialog">
                  <img alt="" src="@/assets/img/assessmentinfo/1231_0.png" class="img-arrow">
                </div>
              </el-col>
              <el-col :span="3" class="container assement-my-container" v-if="item.recruitmentStepList[2].status">
                <div v-if="item.recruitmentStepList[2].status === '10'" class="dialog">
                  <img alt="" src="@/assets/img/ac/1223_5_1.png" class="assement-my-icon">
                  <p class="assement-my-title assement-my-title2">{{ $t('finish') }}</p>
                </div>
                <div class="dialog" v-else>
                  <img alt="" src="@/assets/img/ac/1223_5.png" :class="['assement-my-icon',{'big': item.recruitmentStepList[2].status === '20'}]">
                  <p :class="['assement-my-title',{'big': item.recruitmentStepList[2].status === '20'}]">{{ $t('finish') }}</p>
                </div>
              </el-col>
            </el-row>
            <!-- 下面的操作 -->
            <el-row class="row2">
              <el-col :span="3" class="container" style="height: 70px" v-if="item.recruitmentStepList[0].status">
                <div class="dialog">
                  <!--  状态20 ： 点击进入 状态30：已完成-->
                  <el-link v-if="item.recruitmentStepList[0].status === '20'" type="primary" :underline="false"
                           @click="sendResumeEdit(item.recruitmentStepList[0].isCanEdit,item.userId,item.jobName,item.orgName,item.recruitmentStepList[0].recruitmentId)">
                    点击进入
                  </el-link>
                  <el-link v-if="item.recruitmentStepList[0].status === '30'" type="primary" :underline="false"
                           @click="sendResumeEdit2(item.recruitmentStepList[0].isCanEdit,item.userId,item.jobName,item.orgName,item.recruitmentStepList[0].recruitmentId)">
                    已完成
                  </el-link>
                </div>
              </el-col>
              <el-col :span="2" class="container" style="height: 70px">
                <div class="dialog"></div>
              </el-col>
              <el-col :span="3" class="container" style="height: 70px;" v-if="item.recruitmentStepList[1].status">
                <div class="dialog">
                  <div v-if="item.recruitmentStepList[1].timeAndSite === '' && item.recruitmentStepList[1].status !== '10'">
                    <a class="textB">待完成</a>
                  </div>
                  <a class="textB"
                     v-if="item.recruitmentStepList[1].timeAndSite !== '' && item.recruitmentStepList[1].status !== '10'" v-html="item.recruitmentStepList[1].timeAndSite.replace('|','<br/>')"></a>
                </div>
              </el-col>
              <el-col :span="2" class="container" style="height: 70px">
                <div class="dialog"></div>
              </el-col>
              <el-col :span="3" class="container" style="height: 70px" v-if="item.recruitmentStepList[2].status">
                <div class="dialog">
                  <a class="textB" v-if="item.recruitmentStepList[2].status === '30'">完成</a>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <!--往期申请-->
        <div :style="{position:'absolute', top:(fullHeight * ( 0.4 * (this.dataForm.presentRecruitmentProessList.length - 1)  + 0.73 )  )+ 'px', left: '5%', width: ((fullWidth - 250) * 0.9 ) + 'px'}">
          <div>
            <a style="color: #000000; text-decoration: none;" @click="isShowMsg">
              <span style="font-size:16px;font-weight:400" class="addPointer">
                往期申请
              </span>
              <span v-if="!isShowAssessment">
                <em class="el-icon-arrow-right" style="font-size: 16px;cursor:pointer"></em>
              </span>
              <span v-if="isShowAssessment">
                <em class="el-icon-arrow-down" style="font-size: 16px;cursor:pointer"></em>
              </span>
            </a>
          </div>
          <div style="height: 10px"></div>
          <div class="assessment-msg" v-if="isShowAssessment">
            <div v-if="isShowAssessmentList">
            <div class="el-table el-table--fit el-table--scrollable-x el-table--enable-row-transition"
                 style="width: 100%; height: auto;">
              <div class="el-table__body-wrapper is-scrolling-left" style="height: auto;">
                <table cellspacing="0" border="0" class="el-table__body" style="width: 1800px;" aria-describedby="">
                  <colgroup>
                    <col name="el-table_1_column_1">
                    <col name="el-table_1_column_2">
                    <col name="el-table_1_column_3">
                    <col name="el-table_1_column_4">
                    <col name="el-table_1_column_5">
                    <col name="el-table_1_column_6">
                    <col name="el-table_1_column_8">
                    <col name="el-table_1_column_9">
                    <col name="el-table_1_column_10">
                  </colgroup>
                  <tbody>
                  <!--空白数据-->
                  <tr class="el-table__row">
                    <td rowspan="1" colspan="1" class="el-table_1_column_1">
                      <div class="cell"></div>
                    </td>
                    <td rowspan="1" colspan="1" class="el-table_1_column_2  ">
                      <div class="cell"></div>
                    </td>
                    <td rowspan="1" colspan="1" class="el-table_1_column_3  ">
                      <div class="cell"></div>
                    </td>
                    <td rowspan="1" colspan="1" class="el-table_1_column_4  ">
                      <div class="cell"></div>
                    </td>
                    <td rowspan="1" colspan="1" class="el-table_1_column_5  ">
                      <div class="cell"></div>
                    </td>
                    <td rowspan="1" colspan="1" class="el-table_1_column_6  ">
                      <div class="cell"></div>
                    </td>
                    <td rowspan="1" colspan="1" class="el-table_1_column_7  ">
                      <div class="cell"></div>
                    </td>
                    <td rowspan="1" colspan="1" class="el-table_1_column_8  ">
                      <div class="cell"></div>
                    </td>
                    <td rowspan="1" colspan="1" class="el-table_1_column_9  ">
                      <div class="cell"></div>
                    </td>
                    <td rowspan="1" colspan="1" class="el-table_1_column_10  ">
                      <div class="cell"></div>
                    </td>
                  </tr>
                  <!-- 正式数据-->
                  <tr class="el-table__row" v-for="(item ,i) in dataForm.pastRecruitmentProessList">
                    <td rowspan="1" colspan="1" class="el-table_1_column_1">
                      <div class="cell">
                        <span>
                          职位
                        </span>
                        <label>
                          {{item.jobName}}
                        </label>
                      </div>
                    </td>
                    <td rowspan="1" colspan="2" class="el-table_1_column_3">
                      <div class="cell">
                        <span>
                          能力评估时间
                        </span>
                        <label>
                          {{item.signUpDate}}
                        </label>
                      </div>
                    </td>
                    <td rowspan="1" colspan="1" class="el-table_1_column_4">
                      <div class="cell">
                        <span>
                          场地
                        </span>
                        <label>
                          {{item.signUpLocation}}
                        </label>
                      </div>
                    </td>
                    <!-- <td rowspan="1" colspan="1" class="el-table_1_column_5">
                      <div class="cell">
                        <span>
                          评估中心结果
                        </span>
                        <label>
                          {{item.panelAssessmentResult}}
                        </label>
                      </div>
                    </td> -->
                    <td rowspan="1" colspan="1" class="el-table_1_column_6  ">
                      <div class="cell">
                        <span>
                          发展中心结果
                        </span>
                        <label>
                          {{item.developmentResults}}
                        </label>
                      </div>
                    </td>
                    <td rowspan="1" colspan="1" class="el-table_1_column_8">
                      <div class="cell">
                        <span>
                          经销商
                        </span>
                        <label>
                          {{item.orgName}}
                        </label>
                      </div>
                    </td>
                    <td rowspan="1" colspan="1" class="el-table_1_column_9  ">
                      <div class="cell">
                        <span>
                          品牌
                        </span>
                        <label>
                          {{item.brand}}
                        </label>
                      </div>
                    </td>
                    <td rowspan="1" colspan="1" class="el-table_1_column_10  ">
                      <div class="cell">
                        <span>
                          网点类型
                        </span>
                        <label>
                          {{item.networkType}}
                        </label>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AesUtil from "@/utils/aes_utils";
  export default {
    name: "assessmentlist",
    data() {
      return {
        isShowAssessment: false, // 是否显示往期申请
        isShowAssessmentList: true, // 是否显示往期申请
        fullHeight: document.documentElement.clientHeight, // 页面高度
        fullHeight1: document.documentElement.clientHeight, // 页面高度 _ 用于往期申请 高度使用
        fullWidth: document.documentElement.clientWidth, // 页面宽度  - 250  (左边导航宽度)
        dataForm1: {
          presentRecruitmentProessList: [
            {
              jobName: "MINI 总经理",
              networkTypeCode: "10",
              orgName: "厦门中宝汽车有限公司",
              recruitmentNum: 1,
              jobCode: "920",
              offeringNo: "G00012541",
              signUpDate: "2020-10-16",
              signUpEnddate: "2020-10-16 10:00:00",
              interviewResult: "Pass",
              jobNameCn: "MINI 总经理",
              panelAssessmentResult: "推荐",
              userId: 211222,
              orgId: 349,
              developmentResults: "发展中心状态",
              jobId: 338,
              personalDevelopmentPlan: "个人发展计划",
              signUpLocation: "BMW上海培训中心",
              signUpLocationId: 77,
              recruitmentStepList: [
                {
                  isRecommend: null,
                  jobId: "338",
                  stepDescribe: "提交简历",
                  examTaskIdList: null,
                  recruitmentStepConfId: "1309376737987989505",
                  step: "1",
                  updateTime: null,
                  id: "1316917837633548289",
                  recruitmentId: "1316917836228456450",
                  timeAndSite: null,
                  isCanEdit: "10",
                  status: "20"
                },
                {
                  isRecommend: null,
                  jobId: "338",
                  stepDescribe: "在线测评",
                  examTaskIdList: null,
                  recruitmentStepConfId: "1309376738059292673",
                  step: "2",
                  updateTime: null,
                  id: "1316917837679685634",
                  recruitmentId: "1316917836228456450",
                  timeAndSite: null,
                  isCanEdit: "10",
                  status: "30"
                },
                {
                  isRecommend: "推荐",
                  jobId: "338",
                  stepDescribe: "区域评估",
                  examTaskIdList: null,
                  recruitmentStepConfId: "1309376738118012929",
                  step: "3",
                  updateTime: null,
                  id: "1316917837713240066",
                  recruitmentId: "1316917836228456450",
                  timeAndSite: null,
                  isCanEdit: "10",
                  status: "20"
                },
                {
                  isRecommend: null,
                  jobId: "338",
                  stepDescribe: "能力评估",
                  examTaskIdList: null,
                  recruitmentStepConfId: "1309376738159955970",
                  step: "4",
                  updateTime: "2020-10-20 09:47:25",
                  id: "1316917837730017281",
                  recruitmentId: "1316917836228456450",
                  timeAndSite: "",
                  isCanEdit: "10",
                  status: "20"
                },
                {
                  isRecommend: null,
                  jobId: "338",
                  stepDescribe: "完成",
                  examTaskIdList: null,
                  recruitmentStepConfId: "1309376738227064833",
                  step: "5",
                  updateTime: null,
                  id: "1316917837750988801",
                  recruitmentId: "1316917836228456450",
                  timeAndSite: null,
                  isCanEdit: "10",
                  status: "10"
                }
              ],
              id: "1316917836228456450",
              networkType: "4S",
              brand: "BMW",
              brandCode: "10",
              status: "10"
            },
            {
              jobName: "MINI 市场经理",
              networkTypeCode: "10",
              orgName: "厦门中宝汽车有限公司",
              recruitmentNum: 1,
              jobCode: "820",
              offeringNo: "G00012536",
              signUpDate: "2020-10-16",
              signUpEnddate: "2020-10-16 10:00:00",
              interviewResult: null,
              jobNameCn: "MINI 市场经理",
              panelAssessmentResult: "评估中心结果",
              userId: 1174499,
              orgId: 349,
              developmentResults: "发展中心状态",
              jobId: 326,
              personalDevelopmentPlan: "个人发展计划",
              signUpLocation: "BMW北京培训中心(新)",
              signUpLocationId: 56,
              recruitmentStepList: [
                {
                  isRecommend: null,
                  jobId: "326",
                  stepDescribe: "提交简历",
                  examTaskIdList: null,
                  recruitmentStepConfId: "1309376739288223746",
                  step: "1",
                  updateTime: null,
                  id: "1316645689327005698",
                  recruitmentId: "1316645689071153153",
                  timeAndSite: null,
                  isCanEdit: "20",
                  status: "30"
                },
                {
                  isRecommend: null,
                  jobId: "326",
                  stepDescribe: "在线测评",
                  examTaskIdList: null,
                  recruitmentStepConfId: "1309376739351138305",
                  step: "2",
                  updateTime: null,
                  id: "1316645689347977217",
                  recruitmentId: "1316645689071153153",
                  timeAndSite: null,
                  isCanEdit: "10",
                  status: "30"
                },
                {
                  isRecommend: null,
                  jobId: "326",
                  stepDescribe: "区域评估",
                  examTaskIdList: null,
                  recruitmentStepConfId: "1309376739405664257",
                  step: "3",
                  updateTime: null,
                  id: "1316645689364754434",
                  recruitmentId: "1316645689071153153",
                  timeAndSite: null,
                  isCanEdit: "10",
                  status: "30"
                },
                {
                  isRecommend: null,
                  jobId: "326",
                  stepDescribe: "能力评估",
                  examTaskIdList: null,
                  recruitmentStepConfId: "1309376739472773122",
                  step: "4",
                  updateTime: null,
                  id: "1316645689377337345",
                  recruitmentId: "1316645689071153153",
                  timeAndSite: "2020-10-16|BMW北京培训中心(新)",
                  isCanEdit: "10",
                  status: "10"
                },
                {
                  isRecommend: null,
                  jobId: "326",
                  stepDescribe: "完成",
                  examTaskIdList: null,
                  recruitmentStepConfId: "1309376739514716161",
                  step: "5",
                  updateTime: null,
                  id: "1316645689389920257",
                  recruitmentId: "1316645689071153153",
                  timeAndSite: null,
                  isCanEdit: "10",
                  status: "10"
                }
              ],
              id: "1316645689071153153",
              networkType: "4S",
              brand: "BMW",
              brandCode: "10",
              status: "10"
            }
          ],
          pastRecruitmentProessList: []
        },
        dataForm: {
          presentRecruitmentProessList:[],
          pastRecruitmentProessList: []
        },
      }
    },
    activated() {
      this.init()
    },
    mounted() {
      this.get_bodyHeight()
    },
    methods: {
      // 初始化
      init() {
        this.$request
          .get('/acdc/recruitment/getRecruitmentProessList', {})
          .then((res, total, code, data) => {
            if (data.code === 1) {
              // this.dataForm = data.data
              this.dataForm.presentRecruitmentProessList = data.data.presentRecruitmentProessList
              this.dataForm.pastRecruitmentProessList = data.data.pastRecruitmentProessList
              if(this.dataForm.presentRecruitmentProessList === undefined){
                console.log('presentRecruitmentProessList  undefined')
              }else if(this.dataForm.presentRecruitmentProessList.length === 0){
                this.isShowAssessment = true
              }
              // .replace('|','<br/>')
              // for(let i=0; i<data.data.presentRecruitmentProessList.length; i++){
              //   let timeAndSiteT = data.data.presentRecruitmentProessList[i].recruitmentStepList[3].timeAndSite.replace('|','<br/>')
              //   this.$set(this.dataForm.presentRecruitmentProessList[i].recruitmentStepList[3],'timeAndSiteT',timeAndSiteT)
              // }
              console.log('333', this.dataForm)
            }else {
              this.$message.warning(data.msg)
            }
          })
          .catch((err) => {
            console.log(err)
          })
      },
      get_bodyHeight() {//动态获取浏览器高度
        const that = this
        window.onresize = () => {
          return (() => {
            window.fullHeight = document.documentElement.clientHeight
            window.fullWidth = document.documentElement.clientWidth
            that.fullHeight = window.fullHeight
            that.fullHeight1 = window.fullHeight
            that.fullWidth = window.fullWidth
          })()
        }
      },
      // 是否显示往期申请
      isShowMsg() {
        // 如果有数据 显示 没有数据不显示
        // 重新计算页面高度
        this.isShowAssessmentList = this.dataForm.pastRecruitmentProessList && this.dataForm.pastRecruitmentProessList.length > 0
        if (this.isShowAssessment) {
          if(this.isShowAssessmentList){
            this.fullHeight1 = this.fullHeight1 - 200
          }
          this.isShowAssessment = false
        } else {
          if(this.isShowAssessmentList){
            this.fullHeight1 = this.fullHeight1 + 200
          }
          this.isShowAssessment = true
        }
        console.log('---', this.isShowAssessmentList, this.isShowAssessment)
      },
      // 进入编辑简历
      sendResumeEdit(isCanEdit, id, jobName,orgName,recruitmentId) {
        console.log('sendResumeEdit')
        const base64url = require('base64-url')
        let aes = new AesUtil()
        let userId = '';
        if(id === ''){
          userId = '';
        }else {
          userId = base64url.encode(aes.encrypt(id + ''))
        }
        // 判断进入编辑还是查看简历页面
        if (isCanEdit === '10') {
          // 编辑简历
          this.$router.push({
            name: 'acdc-resume-resumeEdit',
            query: {
              userId: userId,
              export: id,
              jobName: jobName,
              orgName: orgName,
              recruitmentId:recruitmentId,
              isAc: '0'
            }
          })
        }
        if (isCanEdit === '20') {
          // 查看简历
          this.$router.push({
            name: 'acdc-resume-resumePDF',
            query: {
              userId: userId,
              export: id,
              jobName: jobName,
              orgName: orgName,
              recruitmentId:recruitmentId
            }
          })
        }
      },
      // 进入查看简历
      sendResumeEdit2(isCanEdit, id, jobName,orgName,recruitmentId) {
        console.log('sendResumeEdit')
        const base64url = require('base64-url')
        let aes = new AesUtil()
        let userId = '';
        if(id === ''){
          userId = '';
        }else {
          userId = base64url.encode(aes.encrypt(id + ''))
        }
        this.$router.push({
          name: 'acdc-resume-resumePDF',
          query: {
            userId: userId,
            export: id,
            jobName: jobName,
            orgName: orgName,
            recruitmentId:recruitmentId,
            isAssessmentListNew:'0', // 从查看简历跳转编辑简历 返回时候还是查看简历
          }
        })
      },
      // 进入在线测评页面
      sendOnline(recruitmentId, examTaskIdList) {
        // start?examScoreBizId=1319588730032799746&examTaskIdList=1319588730283143169,1319588731096838146
        console.log('sendOnline')
        // 在线测评页面
        this.$router.push({
          name: 'online-start',
          query: {
            examScoreBizId: recruitmentId,
            examTaskIdList: examTaskIdList,
          }
        })
      },
    }
  }
</script>

<style scoped>
  .disabledImg {
    -webkit-filter: grayscale(100%);
    /* Chrome, Safari, Opera */
    filter: grayscale(100%);
    pointer-events: none;
  }

  .assessment-msg {
    white-space: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
  }

  .assessment-msg span {
    font-weight: 600;
    margin-right: 8px;
  }

  .daohang {
    height: 80px;
    width: auto
  }

  .daohangKT {
    height: 100px;
    width: auto
  }

  .container {
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    text-align: center;
    font-size: 0;
    white-space: nowrap;
    overflow: auto;
  }

  .container:after {
    content: '';
    display: inline-block;
    height: 100%;
    vertical-align: middle;
  }

  .dialog {
    display: inline-block;
    vertical-align: middle;
    text-align: left;
    font-size: 14px;
    white-space: normal;
    font-weight: 900;
  }

  .addPointer {
    cursor: pointer;
    text-decoration: none;
  }

  .textA {
    color: #000000;
    font-weight: 400;
    text-decoration: none;
    font-size: 14px;
  }
  .textB {
    color: #000000;
    font-weight: 400;
    text-decoration: none;
    font-size: 14px;
  }
</style>

<style>

  .divider {
    width: 1000px;
  }

  .divider .el-divider {
    background-color: #bbd2e6;
    position: relative;
  }

  .assessment-msg .el-table--enable-row-transition .el-table__body td {
    border-right: 0px #ebeef5 solid;
  }


  .el-divider__text, .el-link {
    font-weight: 400;
    font-size: 14px;
  }

  .container .divrow .el-col-3 {
    width: 9.5%;
  }

  .row1 .el-col-3 {
    width: 9.5%;
  }

  .row2 .el-col-3 {
    width: 9.5%;
  }

  .divUserInfo {
    position: absolute;
    top: calc(calc(100vh - 50px - 38px - 30px) * 0.35);
    left: 5%;
  }

  .divNavigation {
    position: absolute;
    top: calc(calc(100vh - 50px - 38px - 30px) * 0.45);
    left: 15%;
    width: 90%;
  }

  .divPreviousPeriod {
    position: absolute;
    top: calc(calc(100vh - 50px - 38px - 30px) * 0.75);
    left: 5%;
    width: 90%;
  }
</style>
<style lang="scss" scoped>
.assement-my-nav{
  .assement-my-container{
    height: 120px;
    &.assement-my-container2{
      height: 90px;
      .img-arrow{
        width: 25px;
      }
    }
    .assement-my-icon{
      height: 60px;
      width: auto;
      &.big{
        height: 75px;
      }
    }
    .assement-my-title{
      height: 20px;
      line-height: 30px;
      margin: 0;
      text-align: center;
      font-size: 11px;
      color: #417cd9;
      &.assement-my-title2{
        color: #787878;
      }
      &.big{
        font-size: 14px;
        height: 25px;
        line-height: 40px;
      }
    }
  }
}
</style>
